<template>
    <section-layout class="section-header">
        <div class="section-header__content text-center d-flex align-items-center">
            <div class="container d-flex flex-column align-items-center ">
                <img src="@/assets/logo-blue.svg" alt="" class="section-header__logo " />
                <p class="section-header__text text-24 col-sm-15">
                    <span class="heading-24">Enea Akademia Talentów</span> to wspólna inicjatywa Enei i Fundacji Enea – Energia Wspólnoty. Celem projektu jest <span class="heading-24">wspieranie młodych utalentowanych ludzi poprzez przyznawanie im atrakcyjnych stypendiów.</span> W tej edycji pula nagród wynosi <span class="heading-24">400 000 zł.</span> Do konkursu zapraszamy utalentowaną młodzież ze szkół ponadpodstawowych z całej Polski.
                </p>
            </div>
        </div>
    </section-layout>
</template>

<script>
export default {
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
    },
    components: {
    },
    computed: {
    },
};
</script>
